export default __webpack_public_path__ + "static/media/apple-technicians.07bf5e9b.png";